<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog v-model="dialogOpen" :persistent="true" max-width="500">

            <toolbar-page title="Data Variable groups" icon="mdi-gamepad-circle">
                <template slot="buttons">

                    <!-- ADD NEW GROUP MENU -->
                    <v-menu offset-y v-model="createMenuModel" :close-on-content-click="false">
                        <template v-slot:activator="{ on }">

                            <v-btn :disabled="!hasPermission('create data variables')"
                                   v-on="on"
                                   color="primary"
                                   dark
                                   fab
                                   class="ml-2"
                                   small
                            >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>

                        </template>

                        <edit-group-name-card
                            key="create"
                            :groups="groups"
                            @change="create"
                        ></edit-group-name-card>

                    </v-menu>

                    <v-tooltip color="primary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="closeDialog()" v-on="on" icon>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close this dialog</span>
                    </v-tooltip>

                </template>
            </toolbar-page>

            <!-- EXISTING GROUPS TABLE -->
            <v-data-table
                :headers="headers"
                :items="groups"
                item-key="id"
                class="elevation-1"
                :items-per-page="25"
                sort-by="name"
                :footer-props="{itemsPerPageOptions: [10,25,-1]}"
            >

                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.id">

                        <td class="cursor-pointer">

                            <v-tooltip left color="primary" open-delay="500">
                                <template v-slot:activator="{ on }">

                                    <div v-if="item.id!==editId" v-on="on">

                                        <!-- EDIT EXISTING GROUP NAME -->
                                        <v-menu :key="item.id"
                                                offset-y
                                                v-model="item.model"
                                                :close-on-content-click="false">

                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" @click="editGroupName(item)">{{ item.name }}</div>
                                            </template>

                                            <edit-group-name-card
                                                :key="item.id"
                                                :group="item"
                                                :groups="groups"
                                                @change="update"
                                            ></edit-group-name-card>

                                        </v-menu>

                                    </div>
                                </template>
                                <span>Click to rename</span>
                            </v-tooltip>
                        </td>

                        <!-- VARIABLE COUNT -->
                        <td class="text-center">
                            <v-chip :color="item.data_variables_count > 0 ? 'blue-grey' : 'grey darken-2'">
                                {{ item.data_variables_count }}
                            </v-chip>
                        </td>

                        <!-- DELETE BUTTON -->
                        <td class="pa-0 text-center">

                            <div style="white-space: nowrap;">

                                <!-- DELETE BUTTON -->
                                <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-btn :disabled="!hasPermission('delete data variables')"
                                               class="ma-0"
                                               icon
                                               v-on="on"
                                               @click.stop="deleteClicked(item)"
                                        >
                                            <v-icon light small color="white">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Delete group</span>
                                </v-tooltip>
                            </div>

                        </td>
                    </tr>
                    </tbody>
                </template>

            </v-data-table>

        </v-dialog>
    </div>
</template>

<script>

import ToolbarPage from '../../../components/UI/ToolbarPage';
import {mapState, mapActions} from 'vuex';
import EditGroupNameCard from "./EditGroupNameCard";

const vuexModule = 'DataVariables';

export default {

    components: {
        ToolbarPage,
        EditGroupNameCard
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {
            data: {
                id: null,
                name: ''
            },
            editId: null,
            createMenuModel: false,
            highlighted: null,

            headers: [
                {text: 'GROUP', value: 'name'},
                {text: 'COUNT', value: 'data_variables_count', align: 'center'},
                {text: 'DELETE', value: '', align: 'center', sortable: false, width: '40px'},
            ]
        }
    },

    computed: {
        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },
        ...mapState(vuexModule, [
            'groups'
        ])
    },

    methods: {

        ...mapActions(vuexModule, [
            'getGroups',
            'updateGroup',
            'createGroup',
            'deleteGroup'
        ]),

        editGroupName(group) {
            this.data.name = group.name;
            this.data.id = group.id;
        },

        update(group) {
            this.updateGroup(group)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Group updated...'});
                    this.data = {id: null, name: null};
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS group name failed to update!'});
                })
        },

        create(group) {
            this.createMenuModel = false;
            this.createGroup(group)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Group created...'});
                    this.data = {id: null, name: null};
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS we failed to create the group!'});
                });
        },

        deleteClicked(group) {
            this.deleteGroup(group.id)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Group deleted...'});
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS Group failed to delete!'});
                })
        },

        edit(group) {
            this.editId = group.id;
        },

        closeDialog() {
            this.$emit('close');
        }
    }
}
</script>
